import { Button, CardTitle, Badge } from "@cointervue/design-system/components";
import { EditIcon, EyeIcon } from "@assets/Icons";
import type { JobCardHeaderProps } from "./types";
import { capitalizeText, useIsSmallScreen } from "@cointervue/shared";

export default function JobCardHeader({
  jobTitle,
  status,
  onEdit,
  onViewApplicants,
}: JobCardHeaderProps) {
  const isSmallScreen = useIsSmallScreen();
  return (
    <>
      {/* Left Section */}
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <CardTitle
          className="leading-5 min-h-7 max-h-9 line-clamp-2 mt-1"
        >
          {capitalizeText(jobTitle)}
        </CardTitle>
        <Badge
          variant={status === "active" ? "default" : "destructive"}
          className="rounded-xl self-start mt-1 shrink-0"
        >
          {status}
        </Badge>
      </div>

      <div className="flex gap-2">
        <Button variant="secondary" onClick={onEdit} className="flex gap-2">
          <img src={EditIcon} alt="Edit job" className="w-4 h-4 shrink-0" />
          {isSmallScreen ? null : `Edit`}
        </Button>

        <Button
          onClick={onViewApplicants}
          variant="secondary"
          className="flex gap-2"
        >
          <img src={EyeIcon} alt="View applicants" className="w-4 h-4 shrink-0" />
         { isSmallScreen ? null : `View Applicants`}
        </Button>
      </div>
    </>
  );
}
